import React from 'react';
import MapaUbicacion from '../components/mapaUbicacion';
import Contacto from '../components/contacto';
import CarouselContacto from '../components/carouselContacto';
import "./styles.css"
function ContactoMexico(){
    return(
      <div className="animated-background min-h-screen">
      {/* Carrusel con margen superior */}
      <div className="p-12">
        <CarouselContacto />
      </div>
            <div className="container mx-auto flex flex-col md:flex-row items-center p-4">
         <Contacto />
         <MapaUbicacion 
        direccion="Paseo de la Reforma 281,Polanco V Secc, 11560 Ciudad de México" 
        mapaUrl="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7802.480162101868!2d-77.022731!3d-12.09571!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x9105c8655b23c8bb%3A0x2f04088d3e196ff7!2sCa.%20Alfz.%20Mariano%20Santos%20Mateos%20115%2C%20San%20Isidro%2015047%2C%20Per%C3%BA!5e0!3m2!1ses!2sus!4v1740630888742!5m2!1ses!2sus"
      />
    </div>
        </div>
    );

}
export default  ContactoMexico;